module.exports = __webpack_public_path__ + "static/media/coin_img.b71d8241.png";